// services/categoryService.js
import api from './baseAPIService';

// Function to create user question history
export const createUserQuestionHistory = async (questions) => {
    try {
      // Pre-filter questions before mapping to reduce iterations
      const answeredQuestions = questions.filter(question => question.result !== 'not answered');
      
      // Only proceed if there are answered questions
      if (answeredQuestions.length === 0) {
        return { message: "No questions to process" };
      }

      // Create minimal payload
      const histories = answeredQuestions.map(({ id, streak, correct_count, incorrect_count, result }) => ({
        question_id: id,
        streak,
        correct_count,
        incorrect_count,
        was_correct: result === 'Correct'
      }));

      const response = await api.post('/stats/history/batch', { histories });
      return response.data;
    } catch (error) {
      console.error('Error creating user question history:', error);
      throw error;
    }
  };

// Function to delete user question history
export const deleteUserQuestionHistory = async () => {
    try {
      const response = await api.delete('/stats/history');
      return response.data;
    } catch (error) {
      console.error('Error deleting user question history:', error);
      throw error;
    }
  };
  